import { ICategorySortCommand } from "./ICategorySortCommand";

export type SortCardsArgs = {
    order: "asc" | "desc"
}

export class SortCategories implements ICategorySortCommand<SortCardsArgs> {
    sort(items: string[], args: SortCardsArgs = { order: "asc" }): string[] {
        if (!items) {
            return [];
        }

        const numerals = items.filter(x => !!ROMAN_NUMERAL_SORT_MAP[x as RomanNumeral]);
        const nonNumerals = items.filter(x => !!!ROMAN_NUMERAL_SORT_MAP[x as RomanNumeral]);

        numerals.sort((a, b) => {
            const aSortValue = ROMAN_NUMERAL_SORT_MAP[a as RomanNumeral];
            const bSortValue = ROMAN_NUMERAL_SORT_MAP[b as RomanNumeral];

            return args.order === "asc"
                ? aSortValue - bSortValue
                : bSortValue - aSortValue;
        });

        nonNumerals.sort((a, b) => {
            return args.order === "asc"
                ? (a > b ? 1 : -1)
                : (b > a ? 1 : -1);
        });

        return args.order === "asc"
            ? [...numerals, ...nonNumerals]
            : [...nonNumerals, ...numerals];
    }
}

const ROMAN_NUMERALS = ["I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X", "XI", "XII", "XIII", "XIV", "XV", "XVI", "XVII", "XVIII", "XIX", "XX", "XXI", "XXII", "XXIII", "XXIV", "XXV", "XXVI", "XXVII", "XXVIII", "XXIX", "XXX"] as const;
type RomanNumeral = typeof ROMAN_NUMERALS[number];

const ROMAN_NUMERAL_SORT_MAP: Record<RomanNumeral, number> = {
    I: 1,
    II: 2,
    III: 3,
    IV: 4,
    V: 5,
    VI: 6,
    VII: 7,
    VIII: 8,
    IX: 9,
    X: 10,
    XI: 11,
    XII: 12,
    XIII: 13,
    XIV: 14,
    XV: 15,
    XVI: 16,
    XVII: 17,
    XVIII: 18,
    XIX: 19,
    XX: 20,
    XXI: 21,
    XXII: 22,
    XXIII: 23,
    XXIV: 24,
    XXV: 25,
    XXVI: 26,
    XXVII: 27,
    XXVIII: 28,
    XXIX: 29,
    XXX: 30
}